import PropTypes from "prop-types";
import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import { Link } from "../";

var TinyTile = function TinyTile(_ref) {
  var icon = _ref.icon,
      title = _ref.title,
      href = _ref.href,
      newWindow = _ref.newWindow;
  var getClassName = getClassNameFactory(TinyTile.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "icon"
    })
  }, icon), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "link"
    })
  }, /*#__PURE__*/React.createElement(Link, {
    href: href,
    newWindow: newWindow,
    type: "secondary",
    block: true
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "link",
      modifiers: "hiddenOnMobile"
    })
  }, /*#__PURE__*/React.createElement(Link, {
    href: href,
    newWindow: newWindow,
    type: "inline",
    block: true
  }, title)));
};

TinyTile.displayName = "TinyTile";
/* eslint-disable max-len */

TinyTile.propTypes = {
  /**
   * Icon or image component
   */
  icon: PropTypes.node.isRequired,

  /**
   * Title text
   */
  title: PropTypes.string.isRequired,

  /**
   * Href used for link
   */
  href: PropTypes.string.isRequired,

  /**
   * Link opens in new window
   */
  newWindow: PropTypes.bool
};
/* eslint-enable max-len */

TinyTile.defaultProps = {
  newWindow: false
};
export default TinyTile;